export function GetYear() {
  const year = new Date().getFullYear()

  return year
}
